<div id="product-details-section" class="product-details--list">
  <div class="product-details--list-specs">
    <h2 class="mb-3">Product Details</h2>
    <div class="product-details__list">
      <ul id="product-specs-list">
        @for (spec of product.getSpecs(); track spec; let i = $index) {
          <li>
            @if (isLink(spec.key)) {
              <span
                ><strong>{{ spec.key | translate }}:</strong>&nbsp;<a
                  class="link link-underline text-transformation-none fw-normal"
                  href="#"
                  (click)="navigateTo(spec.key, spec.value)"
                  ><span [innerHTML]="spec.value | safeContent"></span></a
              ></span>
            }
            @if (!isLink(spec.key)) {
              @if (spec.key != 'TARIFF_PCT') {
                <span
                  ><strong>{{ spec.key | translate }}:</strong>&nbsp;<span
                    [innerHTML]="spec.value | safeContent"
                  ></span
                ></span>
              }
              @if (spec.key == 'TARIFF_PCT') {
                <span><strong>SUBJECT TO TARIFF</strong></span>
              }
            }
          </li>
        }
        <li>
          <span
            ><strong>Vendor Information:</strong>&nbsp;<span
              ><app-vendor-modal
                [vendorLabel]="vendorLabel"
                class="vendor--container"
              ></app-vendor-modal></span
          ></span>
        </li>
      </ul>
    </div>
  </div>

  <div class="product-details--list-description">
    <div
      id="product-description"
      [innerHTML]="product.content.description | safeContent"
    ></div>
  </div>
</div>
